import {API, getGraphQLPath} from '@/lib/utils/api.utils';
import {isError} from '@epic-mw/error-types';
import {AccountRes} from '@epic-mw/types';

const query = `
    query AccountQuery {
        Account {
            myAccount {
                country
                displayName
                email
                id
                isLoggedIn
                preferredLanguage
                cabinedMode
            }
        }
    }
`;

interface AccountData {
	myAccount?: AccountRes;
}

interface AccountQueryResData {
	Account?: AccountData;
}

interface AccountQueryRes {
	data: AccountQueryResData;
	errors?: unknown;
}

export const getAccount = async (): Promise<AccountRes> => {
	try {
		const response = await API.post<AccountQueryRes>(
			getGraphQLPath(),
			{query},
			{
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				}
			}
		);

		return response?.data?.data?.Account?.myAccount || {};
	} catch (err) {
		console.error('AccountFetch.getAccount() failed to load', isError(err) && err.message);
		throw err;
	}
};
